import { FC } from 'react';
import * as Label from '@radix-ui/react-label';
import getTestId from '@functions/testId';

type Props = {
    htmlFor?: string;
    testId?: string | null;
    children?: string;
};

//DEPRECATED: Start migrating to new Label component

const InputLabel: FC<Props> = ({ htmlFor, children, testId = null }) => {
    return (
        <Label.Root
            className={'text-field-label tw-pb-1.5 tw-font-graphik tw-text-sm tw-leading-[18px] tw-text-navy-900'}
            htmlFor={htmlFor}
            data-testid={getTestId(testId)}
        >
            {children}
        </Label.Root>
    );
};

export default InputLabel;
